import { render, staticRenderFns } from "./jinSung.vue?vue&type=template&id=5f20bfd0&scoped=true"
import script from "./jinSung.vue?vue&type=script&lang=js"
export * from "./jinSung.vue?vue&type=script&lang=js"
import style0 from "./jinSung.vue?vue&type=style&index=0&id=5f20bfd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f20bfd0",
  null
  
)

export default component.exports